import cached from 'utils/cached';

export const geoFromIP = cached(async () => {
	let data = {};
	try {
		let result = await fetch('https://stdata.powster.com/geo');
		data = await result.json();
	} catch (err) {}
	if (!data?.city) {
		try {
			let countryCode = data?.countryCode || __REGION__;
			let capitalURL = new URL('https://stdata.powster.com/capital');
			capitalURL.searchParams.set('country', countryCode.toLowerCase());
			let capitalRes = await fetch(capitalURL);
			if (!capitalRes.ok) throw new Error();
			Object.assign(data, await capitalRes.json());
		} catch (err) {}
	}
	if (data?.countryCode) {
		data.countryCode = data.countryCode.toLowerCase();
	}
	return data;
});